import { Route, Routes } from "react-router-dom";
import { Dashboard, Screening, RoleDesign } from "./pages"; // Only import Dashboard
import { AuthLayout } from "./components/Layouts";
import constants from "./utils/constants";

function App() {
  const paths = constants.ROUTE_PATHS;

  return (
    <div>
      <Routes>
        <Route element={<AuthLayout />}>
          {/* Dashboard Route */}
          <Route path={paths.DASHBOARD} element={<Dashboard />} />

          {/* Self Assessment Routes */}
          <Route path={paths.SELF_ASSESSMENT} element={<Dashboard />} />
          <Route
            path={paths.SELF_ASSESSMENT_RECRUITMENT}
            element={<Dashboard />}
          />
          <Route
            path={paths.SELF_ASSESSMENT_SCREENING}
            element={<Screening />}
          />
          <Route
            path={paths.SELF_ASSESSMENT_TRAINING}
            element={<Dashboard />}
          />
          <Route
            path={paths.SELF_ASSESSMENT_SCHEDULING}
            element={<Dashboard />}
          />
          <Route
            path={paths.SELF_ASSESSMENT_DATA_COLLECTION}
            element={<Dashboard />}
          />
          <Route
            path={paths.SELF_ASSESSMENT_RECOGNITION}
            element={<Dashboard />}
          />
          <Route
            path={paths.SELF_ASSESSMENT_COMMUNICATION}
            element={<Dashboard />}
          />
          <Route
            path={paths.SELF_ASSESSMENT_DATA_SECURITY}
            element={<Dashboard />}
          />
          <Route
            path={paths.SELF_ASSESSMENT_SCORECARD}
            element={<Dashboard />}
          />

          {/* Volunteer Engagement Strategy Routes */}
          <Route path={paths.VOLUNTEER_ENGAGEMENT} element={<Dashboard />} />
          <Route
            path={paths.VOLUNTEER_ENGAGEMENT_MISSION_VISION_GOALS}
            element={<Dashboard />}
          />
          <Route
            path={paths.VOLUNTEER_ENGAGEMENT_ROLE_DESIGN_STRUCTURE}
            element={<RoleDesign />}
          />
          <Route
            path={paths.VOLUNTEER_ENGAGEMENT_SCREENING}
            element={<Dashboard />}
          />
          <Route
            path={paths.VOLUNTEER_ENGAGEMENT_RECRUITMENT_STRATEGY}
            element={<Dashboard />}
          />
          <Route
            path={paths.VOLUNTEER_ENGAGEMENT_ONBOARDING_TRAINING}
            element={<Dashboard />}
          />
          <Route
            path={paths.VOLUNTEER_ENGAGEMENT_ENGAGEMENT_RETENTION}
            element={<Dashboard />}
          />
          <Route
            path={paths.VOLUNTEER_ENGAGEMENT_MEASURING_IMPACT}
            element={<Dashboard />}
          />
          <Route
            path={paths.VOLUNTEER_ENGAGEMENT_FUNDRAISING_PARTNERSHIP}
            element={<Dashboard />}
          />
          <Route
            path={paths.VOLUNTEER_ENGAGEMENT_TECHNOLOGY_AUTOMATION}
            element={<Dashboard />}
          />
          <Route
            path={paths.VOLUNTEER_ENGAGEMENT_FINAL_STRATEGY_REPORT}
            element={<Dashboard />}
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
